import React from "react"
import OmniAural, { useOmniAural } from "omniaural"
import "./ContentModal.css"
import ApprovalResultComponent from "./ApprovalResultComponent"
import DateTimeDisplayComponent from "./DateTimeDisplayComponent"
import PFAInsctructionsImage from "../assets/RegisterForPFAScreenshot.png"

const ContentModal = ({ onClose }) => {
  const [modal] = useOmniAural("modal")
  const { show, data, type, onConfirm } = modal

  if (show === false) {
    return null
  }

  const confirmAndClose = (...args) => {
    onConfirm(...args)
    OmniAural.hideModal()
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={OmniAural.hideModal}>
          X
        </button>
        {type === "deregister" && <DeregisterContent device={data} onConfirm={confirmAndClose} />}
        {type === "challenges" && <ApprovalsList device={data} />}
        {type === "admin_deregister" && (
          <AdminDeregisterContent device={data} onConfirm={confirmAndClose} />
        )}
        {type === "mfa_warning" && <MFAWarningModal deviceName={data} />}
        {type === "make_default_device" && (
          <MakeDefaultDeviceContent device={data} onConfirm={confirmAndClose} />
        )}
      </div>
    </div>
  )
}

const AdminDeregisterContent = ({ device, onConfirm }) => {
  const [reason, setReason] = React.useState("")
  const [customReason, setCustomReason] = React.useState("")

  React.useEffect(() => {
    setCustomReason("")
  }, [reason])

  const reasons = [
    "Lost device",
    "Stolen device",
    "Transferring service to a new device",
    "No longer needs access (e.g. leaving the Military)",
    "No longer wishes to use service",
    "Other"
  ]

  return (
    <div>
      <h2 className="marginL">Deregister users "{device.device_name}"?</h2>
      <div className="marginL marginB">Reason (optional)</div>
      {reasons.map((deregReason) => (
        <div key={deregReason} id="optionAction">
          <input
            type="radio"
            onClick={() => setReason(deregReason)}
            name="reason for deregistering"
            id="dot"
          />
          {deregReason}
        </div>
      ))}
      {reason === "Other" && (
        <input
          type="text"
          id="textInput"
          onChange={(e) => setCustomReason(e.target.value)}
          value={customReason}
        />
      )}
      <div className="buttons-container">
        <button
          type="button"
          className="register-button"
          onClick={() => {
            onConfirm(device.device_id, customReason || reason)
          }}>
          CONFIRM DEREGISTRATION
        </button>
        <button className="cancel-button" onClick={OmniAural.hideModal}>
          CANCEL
        </button>
      </div>
    </div>
  )
}

const DeregisterContent = ({ device, onConfirm }) => {
  return (
    <div className="deregister-content">
      <div>
        <h2>Deregister device "{device.device_name}"</h2>
        <p>
          Are you sure you want to deregister this device? You will no longer be able to use it to
          log in.
        </p>
      </div>
      <div className="buttons-container">
        <button
          type="button"
          className="register-button"
          onClick={() => {
            onConfirm(device.device_id)
          }}>
          CONFIRM DEREGISTRATION
        </button>
        <button type="button" className="cancel-button" onClick={OmniAural.hideModal}>
          CANCEL
        </button>
      </div>
    </div>
  )
}

const ApprovalsList = ({ device }) => {
  return (
    <div>
      <h3>
        {device.challenges.length} authentication attempt(s) for "{device.device_name}" in the last
        30 days
      </h3>
      <div className="approvals-list">
        {device.challenges?.map((approval, index) => (
          <div key={index} className={`approval-row ${index % 2 === 0 ? "even" : "odd"}`}>
            <div className="approval-item">
              <DateTimeDisplayComponent date={approval.responded_at} />
            </div>
            <div className="approval-item">
              <ApprovalResultComponent status={approval.response_status} />
            </div>
            {approval.deny_message && <div className="approval-item">{approval.deny_message}</div>}
          </div>
        ))}
      </div>
    </div>
  )
}

const MFAWarningModal = () => {
  return (
    <div>
      <h2>MFA Only Enabled</h2>
      <p>
        You have not enabled <b>Primary Factor Authentication</b> (PFA) on this device.
      </p>
      <p>
        We recommend upgrading to PFA to protect your account even further and allow you to login
        without a password.
      </p>
      <p>
        You can find the scanner in the MobileConnect App <b>MORE</b> tab.
      </p>
      <br />
      <img
        src={PFAInsctructionsImage}
        className="suggest-register-pfa-instruction-img"
        alt="PFA_register"
      />
      <br />
      Would you like to register now?
      <div className="buttons-container">
        <button className="register-button" onClick={() => (window.location = "/register_pfa")}>
          REGISTER FOR PRIMARY FACTOR
        </button>
        <button type="button" className="cancel-button" onClick={OmniAural.hideModal}>
          CANCEL
        </button>
      </div>
    </div>
  )
}

const MakeDefaultDeviceContent = ({ onConfirm }) => {
  return (
    <div>
      <h2>Make this your default device?</h2>
      <p>
        Make this device the default device for <b> Push Notification Approval </b> and offline
        <b> TOTP </b>
        code entry.
      </p>
      <div className="buttons-container">
        <button className="register-button" onClick={onConfirm}>
          YES, MAKE IT DEFAULT
        </button>
        <button type="button" className="cancel-button" onClick={OmniAural.hideModal}>
          CANCEL
        </button>
      </div>
    </div>
  )
}

export default ContentModal
